// Shared Imports
import { IEnvironment, EEnvironment } from '@shared/models'

export const environment: IEnvironment = {
	production: false,
	operationGatewayMexico: 'https://devzeegw.vemoit.com/oms/mex',
	gateway: 'https://devzeegw.vemoit.com',
	environment: EEnvironment.dev,
	signinRedirectUrl: 'https://devzeeoperation.vemoit.com',
	signoutRedirectUrl: 'https://devzeeoperation.vemoit.com/logout',
}
